import { render, staticRenderFns } from "./Architecture.vue?vue&type=template&id=085c1289&scoped=true&"
import script from "./Architecture.vue?vue&type=script&lang=js&"
export * from "./Architecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c1289",
  null
  
)

export default component.exports